module.exports = __webpack_public_path__ + "img/drops_900.71811571.png";